import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  class: "d-flex justify-content-center align-items-center w-100 flex-column bg-light",
  style: {"height":"100vh"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-3",
  id: "public-logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "card p-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "เข้าสู่ระบบจัดการเว็บไซต์", -1)
const _hoisted_5 = { class: "form-outline my-4" }
const _hoisted_6 = { class: "form-outline mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          id: "form2Example1",
          type: "text",
          placeholder: "ชื่อผู้ใช้",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
        }, null, 512), [
          [_vModelText, _ctx.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          id: "form2Example2",
          type: "password",
          placeholder: "รหัสผ่าน",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
        }, null, 512), [
          [_vModelText, _ctx.password]
        ])
      ]),
      _createElementVNode("a", {
        class: "btn btn-primary btn-block mb-4",
        style: {"background-color":"#332F27"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitLogin())),
        to: "/portal"
      }, "เข้าสู่ระบบ")
    ])
  ]))
}